var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "order__box__price price-box" }, [
    _c(
      "div",
      { staticClass: "forty-percent-width" },
      [
        _c(
          "transition",
          {
            attrs: {
              name: "fade",
              "enter-active-class": "fadeInDown",
              "leave-active-class": "fadeOutDown",
            },
          },
          [
            _vm.pricing !== undefined && _vm.isPriceDiscounted
              ? [
                  _c("span", { staticClass: "discount-percentage-box" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.pricing.price.discount_percentage) +
                        "%\n        "
                    ),
                  ]),
                ]
              : _vm._e(),
          ],
          2
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "sixty-percent-width text-align-right" },
      [
        _c(
          "transition",
          {
            attrs: {
              name: "fade",
              "enter-active-class": "fadeInDown",
              "leave-active-class": "fadeOutDown",
            },
          },
          [
            _vm.pricing !== undefined && _vm.isPriceDiscounted
              ? [
                  _c(
                    "span",
                    { staticClass: "showRetailPrice" },
                    [
                      _c("nobr", [
                        _c("span", { staticClass: "retailPrice" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.pricing.price.final_price.formatted) +
                              "\n            "
                          ),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ]
              : _vm._e(),
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "transition",
          {
            attrs: {
              name: "fade",
              "enter-active-class": "fadeInDown",
              "leave-active-class": "fadeOutDown",
            },
          },
          [
            _vm.pricing !== undefined
              ? [
                  _c(
                    "span",
                    { staticClass: "price finalPrice" },
                    [
                      _c("input", {
                        attrs: {
                          id: "price-brutto",
                          type: "hidden",
                          name: "data[Order][amount]",
                          readonly: "readonly",
                        },
                        domProps: {
                          value:
                            _vm.pricing.price.discounted_price.basePrice.amount,
                        },
                      }),
                      _vm._v(" "),
                      _c("input", {
                        attrs: {
                          id: "price-brutto-currency",
                          type: "hidden",
                          name: "data[Order][currency]",
                          readonly: "readonly",
                        },
                        domProps: {
                          value:
                            _vm.pricing.price.discounted_price.basePrice
                              .currency,
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "transition",
                        {
                          attrs: {
                            name: "fade",
                            "enter-active-class": "fadeInDown",
                            "leave-active-class": "fadeOutDown",
                          },
                        },
                        [
                          _c("nobr", [
                            _c("span", { attrs: { id: "final-price" } }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.pricing.price.discounted_price.formatted
                                  ) +
                                  "\n              "
                              ),
                            ]),
                            _vm._v(" "),
                            _vm.isPriceDiscounted
                              ? _c("span", [_vm._v("*")])
                              : _vm._e(),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.isVatRequired
                        ? [
                            _c(
                              "span",
                              {
                                staticClass: "tax",
                                staticStyle: { display: "block" },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t("payment:checkout.including_vat")
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              : _vm._e(),
          ],
          2
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "button button--expanded",
        attrs: {
          id: "order-submit",
          disabled: !_vm.pricing || _vm.disablePayment || !_vm.locationCheck,
          "data-test-button": "submit",
          type: "submit",
        },
        on: { click: _vm.onOrderSubmit },
      },
      [
        _c(
          "span",
          [
            _vm.locationCheck
              ? [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("general:non_special_texts.continue")) +
                      "\n      "
                  ),
                ]
              : [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("payment:checkout.sold_out")) +
                      "\n      "
                  ),
                ],
          ],
          2
        ),
      ]
    ),
    _vm._v(" "),
    _vm.isPriceDiscounted
      ? _c("span", { staticClass: "discount-legal-text" }, [
          _vm._v(
            "*" +
              _vm._s(
                _vm.$t("payment:checkout.discount_legal_text", {
                  priceFormatted: _vm.pricing.price.final_price.formatted,
                })
              )
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }